

import React, { useState, createContext } from "react";
import { useUserState } from "context/UserContext";
export const RoleContext = createContext();


function RoleContextComponent(props) {
const { user } = useUserState();

 
const GetuserType = ()=> {
     
    if (user.distributor && !user.admin) {
     return ["DISTRIBUTOR"]  

      
      
    }
    if (!user.distributor && user.admin) {
     return  ["ADMINISTRATOR"]   }
       
    if (user.distributor && user.admin) {
      return ["ADMINISTRATOR" ,"DISTRIBUTOR"] }
      // ********
      
    }

    const [fsp, setFsp] = useState(
        localStorage.getItem('roleListFSP') && JSON.parse(localStorage.getItem("roleListFSP")) ?
            JSON.parse(localStorage.getItem("roleListFSP")) :
            {
                page: 1, pageSize: 10,
                freeField: "",
                order: null,
                orderBy: null,
                actif: true,
                inactif: false,
                // other filters
                types: GetuserType(),
                distributorId:""
            })

    return (
        <RoleContext.Provider
            value={{
                fsp,
                setFsp: (fsp) => {
                    setFsp(fsp)
                    if (localStorage.getItem('roleListFSP')) {
                        localStorage.setItem("roleListFSP", JSON.stringify({ ...JSON.parse(localStorage.getItem("roleListFSP")), ...fsp }))
                    }
                    else {
                        localStorage.setItem("roleListFSP", JSON.stringify({ ...fsp }))
                    }
                }
            }}
        >
            {props.children}
        </RoleContext.Provider>
    );

}

export default RoleContextComponent;